import {toJson, isArray, inArray, isObject} from './../utils'
import {APIServiceError} from './APIServiceError'

export const API_RESPONSE_STATUS_SUCCESS = 0,
      API_RESPONSE_STATUS_ERROR = 1,
      API_RESPONSE_STATUS_VALIDATION_ERROR = 2

/**
 * This class is a js mirror of the PHP @base-utils ResponseDTO class.
 * Please set its props only through constructor()
 */
export class ResponseDTO
{
    static get STATUS_SUCCESS() {
        return API_RESPONSE_STATUS_SUCCESS
    }

    static get STATUS_ERROR() {
        return API_RESPONSE_STATUS_ERROR
    }

    static get STATUS_VALIDATION_ERROR() {
        return API_RESPONSE_STATUS_VALIDATION_ERROR
    }

    constructor(
        message,
        status = API_RESPONSE_STATUS_ERROR,
        data = {},
        errors = {},
        errorCode = null,
        responseHeaders = {},
        additional = {}
    ) {
        // ---------- Validate parameters ---------- //

        if( status === undefined ) {
            status = API_RESPONSE_STATUS_ERROR
        } else if ( ! inArray(status, [API_RESPONSE_STATUS_SUCCESS, API_RESPONSE_STATUS_ERROR, API_RESPONSE_STATUS_VALIDATION_ERROR]) ) {
            throw new APIServiceError('[ResponseDTO::constructor()] Invalid "status" parameter!')
        }
        status = parseInt(status)

        if( data === undefined ) {
            data = {}
        } else if ( ! isObject(data) && ! isArray(data) ) {
            throw new APIServiceError('[ResponseDTO::constructor()] Parameter "data" need to be an object or array!')
        }

        if( errors === undefined ) {
            errors = {}
        } else if ( ! isObject(errors) && ! isArray(errors) ) {
            throw new APIServiceError('[ResponseDTO::constructor()] Parameter "errors" need to be an object or array!')
        }

        if( errorCode === undefined ) {
            errorCode = null
        }

        if( responseHeaders === undefined ) {
            responseHeaders = {}
        } else if ( ! isObject(responseHeaders) && ! isArray(responseHeaders) ) {
            throw new APIServiceError('[ResponseDTO::constructor()] Parameter "responseHeaders" need to be an object or array!')
        }

        if( additional === undefined ) {
            additional = {}
        } else if ( ! isObject(additional) && ! isArray(additional) ) {
            throw new APIServiceError('[ResponseDTO::constructor()] Parameter "additional" need to be an object or array!')
        }

        // ------------------------------ //

        this.status = status
        this.message = message
        this.data = data
        this.errorCode = errorCode
        this.errors = errors
        this.responseHeaders = responseHeaders
        this.additional = additional
    }

    asJSON()
    {
        return toJson(this)
    }

    // -------------------------------- //

    success() {
        return this.getStatus() === API_RESPONSE_STATUS_SUCCESS
    }

    getStatus() {
        return this.status
    }

    getMessage() {
        return this.message
    }

    getData(key = null, otherwise = null) {
        if( key !== null ) {
            let result = this.data[key]
            return result === '' || result === undefined ? otherwise : result
        }

        return this.data
    }

    getErrorCode() {
        return this.errorCode
    }

    getErrors() {
        return this.errors
    }

    getResponseHeaders() {
        return this.responseHeaders
    }

    getAdditional() {
        return this.additional
    }
}
